module.exports = __webpack_public_path__ + "img/Feature.edd332a9.png";